(() => {
  'use strict';
  // Custom setup engines validate and add their own complete, uniquely tagged selection.
  // Refresh the existing drawer afterwards; never submit those items a second time.
  window.BlackBearCart = {
    async open(fallback = '/cart') {
      const api = window.SectionStoreCart;
      if (!api) { window.location.assign(fallback); return; }
      try {
        await api.ready;
        const cart = await api.refresh();
        updateCount(cart);
        api.open();
      } catch (error) {
        console.warn('Basket saved; opening the basket page.', error);
        window.location.assign(fallback);
      }
    }
  };
  function updateCount(cart) {
    if (!cart || !Number.isFinite(cart.item_count)) return;
    document.querySelectorAll('#cart-icon-bubble .wbhcartitem').forEach(el => { el.textContent = cart.item_count; });
  }
  window.addEventListener('section-store:cart:updated', event => updateCount(event.detail?.cart));
  function stickyButtons() {
    document.querySelectorAll('.bos-pdp [data-sticky]').forEach(sticky => {
      const root = sticky.closest('.bos-pdp');
      const form = root?.querySelector('[data-buy-form]');
      const primary = root?.querySelector('[data-add]');
      const link = sticky.querySelector('a.bos-button');
      if (!form || !primary || !link) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = link.className;
      const sync = () => { button.textContent = primary.textContent; button.disabled = primary.disabled; };
      sync(); link.replaceWith(button);
      new MutationObserver(sync).observe(primary, { attributes: true, childList: true, subtree: true });
      button.addEventListener('click', () => { if (!primary.disabled) form.requestSubmit(primary); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stickyButtons);
  else stickyButtons();
  document.addEventListener('shopify:section:load', stickyButtons);
})();
